export const SET_VEHICLE_CONFIGURATION = 'SET_VEHICLE_CONFIGURATION';
export const SET_YEAR = 'SET_YEAR';
export const SET_MAKE = 'SET_MAKE';
export const SET_MODEL = 'SET_MODEL';
export const SET_IMAGE = 'SET_IMAGE';
export const SET_BODYSTYLE = 'SET_BODYSTYLE';
export const SET_PRICE = 'SET_PRICE';
export const SET_OPTIONS = 'SET_OPTIONS';
export const SET_DRIVETRAIN = 'SET_DRIVETRAIN';
export const SET_CAB = 'SET_CAB';
export const SET_PAINT = 'SET_PAINT';
export const SET_INTERIOR = 'SET_INTERIOR';
export const SET_PACKAGES = 'SET_PACKAGES';
export const SET_PACKAGES_SELECTIONS = 'SET_PACKAGES_SELECTIONS';
export const SET_TRIM = 'SET_TRIM';
export const SET_TRIM_ID = 'SET_TRIM_ID';
export const SET_ACCOUNT_FRANCHISE_LIST = 'SET_ACCOUNT_FRANCHISE_LIST';
export const SET_FRANCHISE_MODELS = 'SET_FRANCHISE_MODELS';
export const SET_SELECTED_FRANCHISE = 'SET_SELECTED_FRANCHISE';
export const SET_ACCOUNT_DATA = 'SET_ACCOUNT_DATA';
export const SET_TRIM_DATA = 'SET_TRIM_DATA';
export const SET_SELECTED_TRIM_DATA = 'SET_SELECTED_TRIM_DATA';
export const SET_SELECTED_TRIM_COLOR_DATA = 'SET_SELECTED_TRIM_COLOR_DATA';
export const SET_SELECTED_TRIM_PACKAGE_DATA = 'SET_SELECTED_TRIM_PACKAGE_DATA';
export const SET_ENABLE_CONTINUE_BTN = 'SET_ENABLE_CONTINUE_BTN';
export const SET_DISABLE_CONTINUE_BTN = 'SET_DISABLE_CONTINUE_BTN';
export const SET_ACCOUNT_THEME_KIT = 'SET_ACCOUNT_THEME_KIT';
export const SET_ROOT_DIRECTORY = 'SET_ROOT_DIRECTORY';
export const SET_INCLUDE_DESTINATION_CHARGE_IN_PRICE =
	'SET_INCLUDE_DESTINATION_CHARGE_IN_PRICE';
